import { createTheme } from "@mui/material";

const theme = createTheme({
    spacing: 4,
    typography: {
        fontFamily: 'Inter, Arial, sans-serif !important',
      },
    status: {
        danger: '#FF4500',
    },
    backgroundColor: '#D9E4CD',
    palette: {
        divider: '#E1E1E1',
        text: {
            primary: '#1D1D1D',
            secondary: '#686868',
            disabled: '#8D8D8D',
            accent: '#109CF1',
            darkBlue: '#334D6E',
            dark:'#000000',
            highLight:"#00A3FF"
        },
        Primary: {
            main: '#5A404E',
            dark: '#3D2113',
            light: '#F9F4F6',
            background: '#8C2148',
            border: '#52250F',
            contrastText: '#FFFFFF',
            hoverButton: '#7D1239'
        },
        Secondary: {
            main: '#D1581B',
            dark: '#00766C',
            light: '#64D8CB',
            background: '#F7F8F9',
            border: '#84C4BE',
            contrastText: '#FFFFFF',
            hoverButton: '#EFEFEF'
        },
        Other: {
            stroke: '#C4C4C4',
            divider: '#E3E3E3',
            backdrop: '#717171',
            snackbar: '#323232',
            activeRating: '#FFB400',
            background: '#D0C5CA',
            titleText: '#B56161'
        },
        Warning: {
            main: '#FF9800',
            dark: '#C77700',
            light: '#FFB547',
            textDark: '#663D00',
            lightBg: '#FFF5E5',
            border: '#F1BD71',
            contrastText: '#1D1D1D',
        },
        Error: {
            main: '#F44336',
            dark: '#E31B0C',
            light: '#F88078',
            textDark: '#621B16',
            lightBg: '#FEECEB',
            border: '#EB928C',
            contrastText: '#FFFFFF',
        },
        Success: {
            main: '#2E7D32',
            dark: '#1B5E20',
            light: '#4CAF50',
            background: '#2E7D32',
            border: '#E99D84',
            contrastText: '#FFFFFF',
        },
        Actions: {
            active: '#F15927',
            hover: '#B72300',
            selected: '#B72300',
            disabled: '#BDBDBD',
            disabledBackground: '#E0E0E0',
            background:"#E5E5E5",
            focus: '#F15927',
        },
        background: {
            white: '#FFFFFF',
            gray: '#E5E5E5',
            darkGray: '#707683',
            pink: "#F4E7EC",
        },
        icon: {
            gray: '#C2CFE0',
            blue: '#024FE4',
        },
        border: {
            gray: '#EBEFF2'
        },
        login:{
            forgotLink:'#00A3FF',
            loginButton:'#8C2148',
            unselected:'#B0B0B0',
        },
        status:{
            open:'#FF7C02',
            closed:'#48742C',
            added: '#7B7B7B',
            pendingApproval: '#F7931D',
            approved: '#48742C',
            review: '#D3291D',
            audited: '#024FE4',
            verified: '#00FFFF'
        },
        trade:{
            header:"#377E7F",
            button:"#2A6565",
            background:"#D9D9D9",
            secondary:"#377E7F",
            secondBackground:"#40C1C1",
            tradeTableBackground:"#BAC6C6"
        }
    },
});

export default theme;
